import { render, staticRenderFns } from "./parts-tracker.vue?vue&type=template&id=825abc88"
import script from "./parts-tracker.vue?vue&type=script&lang=js"
export * from "./parts-tracker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports